import useVisible from '@/shared/hooks/useVisible';
import { Modal } from '@/shared/ui';
import { PublishOptionPopup } from '@/widgets/modal';
import * as Tooltip from '@radix-ui/react-tooltip';
interface PublishButtonProps {
    containerClass?: string;
    showTooltip?: boolean;
    tooltipText?: string;
    buttonText?: string;
    styles: {
        button?: string;
        tooltip?: string;
    };
    onRefetch?: () => void;
    icon?: boolean;
    checkList?: DATA.Exam[] | API.CreatedBoxDetail.Res[];
    disabled?: boolean;
}

export const PublishButton = ({
    showTooltip = false,
    tooltipText = '발행',
    buttonText,
    styles,
    icon = false,
    checkList,
    disabled,
}: PublishButtonProps) => {
    const [isVisible, setIsVisible] = useVisible();

    return (
        <>
            <Modal open={isVisible} onClose={setIsVisible} isCustom={true}>
                <PublishOptionPopup checkList={checkList!} onClose={setIsVisible} />
            </Modal>
            {showTooltip ? (
                <Tooltip.Provider>
                    <Tooltip.Root>
                        <Tooltip.Trigger asChild>
                            <button type="button" className={styles.button} onClick={setIsVisible}>
                                <span className={styles.tooltip ?? 'tooltip'}>{tooltipText}</span>
                                {buttonText && buttonText}
                            </button>
                        </Tooltip.Trigger>
                    </Tooltip.Root>
                </Tooltip.Provider>
            ) : (
                <button
                    type="button"
                    className={styles.button}
                    onClick={setIsVisible}
                    disabled={(checkList && checkList?.length === 0) || disabled}
                >
                    {icon && <i></i>}
                    {buttonText}
                </button>
            )}
        </>
    );
};
